export const bindTitle = "BindPage.BindModal.title";
export const account = "BindPage.BindModal.account";
export const accountRequired = "BindPage.BindModal.account.required";
export const password = "BindPage.BindModal.password";
export const passwordRequired = "BindPage.BindModal.password.required";
export const ok = "BindPage.BindModal.okText";
export const cancel = "BindPage.BindModal.cancelText";
